export default "__VITE_ASSET__CvP98ggt__$_?nuxt_component=async&nuxt_component_name=IconUpdown&nuxt_component_export=default__"